import { render } from "./DashboardTemplatesSettings.vue?vue&type=template&id=3d9fee6f&scoped=true"
import script from "./DashboardTemplatesSettings.vue?vue&type=script&lang=js"
export * from "./DashboardTemplatesSettings.vue?vue&type=script&lang=js"

import "./DashboardTemplatesSettings.vue?vue&type=style&index=0&id=3d9fee6f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d9fee6f"]])

export default __exports__